var Mt = Object.defineProperty;
var Ht = (r, o, e) => o in r ? Mt(r, o, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[o] = e;
var x = (r, o, e) => Ht(r, typeof o != "symbol" ? o + "" : o, e);
import { openBlock as i, createElementBlock as u, createElementVNode as H, ref as p, watchEffect as W, defineComponent as gt, computed as k, onMounted as xt, onUnmounted as Dt, normalizeClass as _, normalizeStyle as Ct, unref as lt, createVNode as j, createCommentVNode as F, createBlock as G, resolveDynamicComponent as nt, mergeProps as it, Fragment as R, renderSlot as I, normalizeProps as kt, createTextVNode as Tt, toDisplayString as rt, renderList as dt, useAttrs as Lt, nextTick as Yt, watch as Bt, withCtx as X } from "vue";
function Ot(r) {
  if (!r || typeof document > "u") return;
  let o = document.head || document.getElementsByTagName("head")[0], e = document.createElement("style");
  e.type = "text/css", o.appendChild(e), e.styleSheet ? e.styleSheet.cssText = r : e.appendChild(document.createTextNode(r));
}
Ot("[data-sonner-toaster][dir=ltr],html[dir=ltr]{--toast-icon-margin-start:-3px;--toast-icon-margin-end:4px;--toast-svg-margin-start:-1px;--toast-svg-margin-end:0px;--toast-button-margin-start:auto;--toast-button-margin-end:0;--toast-close-button-start:0;--toast-close-button-end:unset;--toast-close-button-transform:translate(-35%, -35%)}[data-sonner-toaster][dir=rtl],html[dir=rtl]{--toast-icon-margin-start:4px;--toast-icon-margin-end:-3px;--toast-svg-margin-start:0px;--toast-svg-margin-end:-1px;--toast-button-margin-start:0;--toast-button-margin-end:auto;--toast-close-button-start:unset;--toast-close-button-end:0;--toast-close-button-transform:translate(35%, -35%)}[data-sonner-toaster]{position:fixed;width:var(--width);font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;--gray1:hsl(0, 0%, 99%);--gray2:hsl(0, 0%, 97.3%);--gray3:hsl(0, 0%, 95.1%);--gray4:hsl(0, 0%, 93%);--gray5:hsl(0, 0%, 90.9%);--gray6:hsl(0, 0%, 88.7%);--gray7:hsl(0, 0%, 85.8%);--gray8:hsl(0, 0%, 78%);--gray9:hsl(0, 0%, 56.1%);--gray10:hsl(0, 0%, 52.3%);--gray11:hsl(0, 0%, 43.5%);--gray12:hsl(0, 0%, 9%);--border-radius:8px;box-sizing:border-box;padding:0;margin:0;list-style:none;outline:0;z-index:999999999}[data-sonner-toaster][data-x-position=right]{right:max(var(--offset),env(safe-area-inset-right))}[data-sonner-toaster][data-x-position=left]{left:max(var(--offset),env(safe-area-inset-left))}[data-sonner-toaster][data-x-position=center]{left:50%;transform:translateX(-50%)}[data-sonner-toaster][data-y-position=top]{top:max(var(--offset),env(safe-area-inset-top))}[data-sonner-toaster][data-y-position=bottom]{bottom:max(var(--offset),env(safe-area-inset-bottom))}[data-sonner-toast]{--y:translateY(100%);--lift-amount:calc(var(--lift) * var(--gap));z-index:var(--z-index);position:absolute;opacity:0;transform:var(--y);touch-action:none;will-change:transform,opacity,height;transition:transform .4s,opacity .4s,height .4s,box-shadow .2s;box-sizing:border-box;outline:0;overflow-wrap:anywhere}[data-sonner-toast][data-styled=true]{padding:16px;background:var(--normal-bg);border:1px solid var(--normal-border);color:var(--normal-text);border-radius:var(--border-radius);box-shadow:0 4px 12px rgba(0,0,0,.1);width:var(--width);font-size:13px;display:flex;align-items:center;gap:6px}[data-sonner-toast]:focus-visible{box-shadow:0 4px 12px rgba(0,0,0,.1),0 0 0 2px rgba(0,0,0,.2)}[data-sonner-toast] [data-buttons]{display:flex;gap:8px;margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end)}[data-sonner-toast][data-y-position=top]{top:0;--y:translateY(-100%);--lift:1;--lift-amount:calc(1 * var(--gap))}[data-sonner-toast][data-y-position=bottom]{bottom:0;--y:translateY(100%);--lift:-1;--lift-amount:calc(var(--lift) * var(--gap))}[data-sonner-toast] [data-description]{font-weight:400;line-height:1.4;color:inherit}[data-sonner-toast] [data-title]{font-weight:500;line-height:1.5;color:inherit}[data-sonner-toast] [data-icon]{display:flex;height:16px;width:16px;position:relative;justify-content:flex-start;align-items:center;flex-shrink:0;margin-left:var(--toast-icon-margin-start);margin-right:var(--toast-icon-margin-end)}[data-sonner-toast][data-promise=true] [data-icon]>svg{opacity:0;transform:scale(.8);transform-origin:center;animation:sonner-fade-in .3s ease forwards}[data-sonner-toast] [data-icon]>*{flex-shrink:0}[data-sonner-toast] [data-icon] svg{margin-left:var(--toast-svg-margin-start);margin-right:var(--toast-svg-margin-end)}[data-sonner-toast] [data-content]{display:flex;flex-direction:column;gap:2px;transform:translateZ(0)}[data-sonner-toast] [data-button]{border-radius:4px;padding-left:8px;padding-right:8px;height:24px;font-size:12px;color:var(--normal-bg);background:var(--normal-text);margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end);border:none;cursor:pointer;outline:0;display:flex;align-items:center;flex-shrink:0;transition:opacity .4s,box-shadow .2s}[data-sonner-toast] [data-button]:focus-visible{box-shadow:0 0 0 2px rgba(0,0,0,.4)}[data-sonner-toast] [data-button]:first-of-type{margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end)}[data-sonner-toast] [data-cancel]{color:var(--normal-text);background:rgba(0,0,0,.08)}[data-sonner-toast][data-theme=dark] [data-cancel]{background:rgba(255,255,255,.3)}[data-sonner-toast] [data-close-button]{position:absolute;left:var(--toast-close-button-start);right:var(--toast-close-button-end);top:0;height:20px;width:20px;display:flex;justify-content:center;align-items:center;padding:0;background:var(--gray1);color:var(--gray12);border:1px solid var(--gray4);transform:var(--toast-close-button-transform);border-radius:50%;cursor:pointer;z-index:1;transition:opacity .1s,background .2s,border-color .2s}[data-sonner-toast] [data-close-button]:focus-visible{box-shadow:0 4px 12px rgba(0,0,0,.1),0 0 0 2px rgba(0,0,0,.2)}[data-sonner-toast] [data-disabled=true]{cursor:not-allowed}[data-sonner-toast]:hover [data-close-button]:hover{background:var(--gray2);border-color:var(--gray5)}[data-sonner-toast][data-swiping=true]:before{content:'';position:absolute;left:0;right:0;height:100%;z-index:-1}[data-sonner-toast][data-y-position=top][data-swiping=true]:before{bottom:50%;transform:scaleY(3) translateY(50%)}[data-sonner-toast][data-y-position=bottom][data-swiping=true]:before{top:50%;transform:scaleY(3) translateY(-50%)}[data-sonner-toast][data-swiping=false][data-removed=true]:before{content:'';position:absolute;inset:0;transform:scaleY(2)}[data-sonner-toast]:after{content:'';position:absolute;left:0;height:calc(var(--gap) + 1px);bottom:100%;width:100%}[data-sonner-toast][data-mounted=true]{--y:translateY(0);opacity:1}[data-sonner-toast][data-expanded=false][data-front=false]{--scale:var(--toasts-before) * 0.05 + 1;--y:translateY(calc(var(--lift-amount) * var(--toasts-before))) scale(calc(-1 * var(--scale)));height:var(--front-toast-height)}[data-sonner-toast]>*{transition:opacity .4s}[data-sonner-toast][data-expanded=false][data-front=false][data-styled=true]>*{opacity:0}[data-sonner-toast][data-visible=false]{opacity:0;pointer-events:none}[data-sonner-toast][data-mounted=true][data-expanded=true]{--y:translateY(calc(var(--lift) * var(--offset)));height:var(--initial-height)}[data-sonner-toast][data-removed=true][data-front=true][data-swipe-out=false]{--y:translateY(calc(var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=true]{--y:translateY(calc(var(--lift) * var(--offset) + var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=false]{--y:translateY(40%);opacity:0;transition:transform .5s,opacity .2s}[data-sonner-toast][data-removed=true][data-front=false]:before{height:calc(var(--initial-height) + 20%)}[data-sonner-toast][data-swiping=true]{transform:var(--y) translateY(var(--swipe-amount,0));transition:none}[data-sonner-toast][data-swipe-out=true][data-y-position=bottom],[data-sonner-toast][data-swipe-out=true][data-y-position=top]{animation:swipe-out .2s ease-out forwards}@keyframes swipe-out{from{transform:translateY(calc(var(--lift) * var(--offset) + var(--swipe-amount)));opacity:1}to{transform:translateY(calc(var(--lift) * var(--offset) + var(--swipe-amount) + var(--lift) * -100%));opacity:0}}@media (max-width:600px){[data-sonner-toaster]{position:fixed;--mobile-offset:16px;right:var(--mobile-offset);left:var(--mobile-offset);width:100%}[data-sonner-toaster] [data-sonner-toast]{left:0;right:0;width:calc(100% - 32px)}[data-sonner-toaster][data-x-position=left]{left:var(--mobile-offset)}[data-sonner-toaster][data-y-position=bottom]{bottom:20px}[data-sonner-toaster][data-y-position=top]{top:20px}[data-sonner-toaster][data-x-position=center]{left:var(--mobile-offset);right:var(--mobile-offset);transform:none}}[data-sonner-toaster][data-theme=light]{--normal-bg:#fff;--normal-border:var(--gray4);--normal-text:var(--gray12);--success-bg:hsl(143, 85%, 96%);--success-border:hsl(145, 92%, 91%);--success-text:hsl(140, 100%, 27%);--info-bg:hsl(208, 100%, 97%);--info-border:hsl(221, 91%, 91%);--info-text:hsl(210, 92%, 45%);--warning-bg:hsl(49, 100%, 97%);--warning-border:hsl(49, 91%, 91%);--warning-text:hsl(31, 92%, 45%);--error-bg:hsl(359, 100%, 97%);--error-border:hsl(359, 100%, 94%);--error-text:hsl(360, 100%, 45%)}[data-sonner-toaster][data-theme=light] [data-sonner-toast][data-invert=true]{--normal-bg:#000;--normal-border:hsl(0, 0%, 20%);--normal-text:var(--gray1)}[data-sonner-toaster][data-theme=dark] [data-sonner-toast][data-invert=true]{--normal-bg:#fff;--normal-border:var(--gray3);--normal-text:var(--gray12)}[data-sonner-toaster][data-theme=dark]{--normal-bg:#000;--normal-border:hsl(0, 0%, 20%);--normal-text:var(--gray1);--success-bg:hsl(150, 100%, 6%);--success-border:hsl(147, 100%, 12%);--success-text:hsl(150, 86%, 65%);--info-bg:hsl(215, 100%, 6%);--info-border:hsl(223, 100%, 12%);--info-text:hsl(216, 87%, 65%);--warning-bg:hsl(64, 100%, 6%);--warning-border:hsl(60, 100%, 12%);--warning-text:hsl(46, 87%, 65%);--error-bg:hsl(358, 76%, 10%);--error-border:hsl(357, 89%, 16%);--error-text:hsl(358, 100%, 81%)}[data-rich-colors=true] [data-sonner-toast][data-type=success]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true] [data-sonner-toast][data-type=success] [data-close-button]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true] [data-sonner-toast][data-type=info]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true] [data-sonner-toast][data-type=info] [data-close-button]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true] [data-sonner-toast][data-type=warning]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true] [data-sonner-toast][data-type=warning] [data-close-button]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true] [data-sonner-toast][data-type=error]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}[data-rich-colors=true] [data-sonner-toast][data-type=error] [data-close-button]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}.sonner-loading-wrapper{--size:16px;height:var(--size);width:var(--size);position:absolute;inset:0;z-index:10}.sonner-loading-wrapper[data-visible=false]{transform-origin:center;animation:sonner-fade-out .2s ease forwards}.sonner-spinner{position:relative;top:50%;left:50%;height:var(--size);width:var(--size)}.sonner-loading-bar{animation:sonner-spin 1.2s linear infinite;background:var(--gray11);border-radius:6px;height:8%;left:-10%;position:absolute;top:-3.9%;width:24%}.sonner-loading-bar:first-child{animation-delay:-1.2s;transform:rotate(.0001deg) translate(146%)}.sonner-loading-bar:nth-child(2){animation-delay:-1.1s;transform:rotate(30deg) translate(146%)}.sonner-loading-bar:nth-child(3){animation-delay:-1s;transform:rotate(60deg) translate(146%)}.sonner-loading-bar:nth-child(4){animation-delay:-.9s;transform:rotate(90deg) translate(146%)}.sonner-loading-bar:nth-child(5){animation-delay:-.8s;transform:rotate(120deg) translate(146%)}.sonner-loading-bar:nth-child(6){animation-delay:-.7s;transform:rotate(150deg) translate(146%)}.sonner-loading-bar:nth-child(7){animation-delay:-.6s;transform:rotate(180deg) translate(146%)}.sonner-loading-bar:nth-child(8){animation-delay:-.5s;transform:rotate(210deg) translate(146%)}.sonner-loading-bar:nth-child(9){animation-delay:-.4s;transform:rotate(240deg) translate(146%)}.sonner-loading-bar:nth-child(10){animation-delay:-.3s;transform:rotate(270deg) translate(146%)}.sonner-loading-bar:nth-child(11){animation-delay:-.2s;transform:rotate(300deg) translate(146%)}.sonner-loading-bar:nth-child(12){animation-delay:-.1s;transform:rotate(330deg) translate(146%)}@keyframes sonner-fade-in{0%{opacity:0;transform:scale(.8)}100%{opacity:1;transform:scale(1)}}@keyframes sonner-fade-out{0%{opacity:1;transform:scale(1)}100%{opacity:0;transform:scale(.8)}}@keyframes sonner-spin{0%{opacity:1}100%{opacity:.15}}@media (prefers-reduced-motion){.sonner-loading-bar,[data-sonner-toast],[data-sonner-toast]>*{transition:none!important;animation:none!important}}.sonner-loader{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);transform-origin:center;transition:opacity .2s,transform .2s}.sonner-loader[data-visible=false]{opacity:0;transform:scale(.8) translate(-50%,-50%)}");
let pt = 0;
class Nt {
  constructor() {
    x(this, "subscribers");
    x(this, "toasts");
    // We use arrow functions to maintain the correct `this` reference
    x(this, "subscribe", (o) => (this.subscribers.push(o), () => {
      const e = this.subscribers.indexOf(o);
      this.subscribers.splice(e, 1);
    }));
    x(this, "publish", (o) => {
      this.subscribers.forEach((e) => e(o));
    });
    x(this, "addToast", (o) => {
      this.publish(o), this.toasts = [...this.toasts, o];
    });
    x(this, "create", (o) => {
      var b;
      const { message: e, ...a } = o, m = typeof o.id == "number" || o.id && ((b = o.id) == null ? void 0 : b.length) > 0 ? o.id : pt++, f = this.toasts.find((d) => d.id === m), g = o.dismissible === void 0 ? !0 : o.dismissible;
      return f ? this.toasts = this.toasts.map((d) => d.id === m ? (this.publish({ ...d, ...o, id: m, title: e }), {
        ...d,
        ...o,
        id: m,
        dismissible: g,
        title: e
      }) : d) : this.addToast({ title: e, ...a, dismissible: g, id: m }), m;
    });
    x(this, "dismiss", (o) => (o || this.toasts.forEach((e) => {
      this.subscribers.forEach(
        (a) => a({ id: e.id, dismiss: !0 })
      );
    }), this.subscribers.forEach((e) => e({ id: o, dismiss: !0 })), o));
    x(this, "message", (o, e) => this.create({ ...e, message: o, type: "default" }));
    x(this, "error", (o, e) => this.create({ ...e, type: "error", message: o }));
    x(this, "success", (o, e) => this.create({ ...e, type: "success", message: o }));
    x(this, "info", (o, e) => this.create({ ...e, type: "info", message: o }));
    x(this, "warning", (o, e) => this.create({ ...e, type: "warning", message: o }));
    x(this, "loading", (o, e) => this.create({ ...e, type: "loading", message: o }));
    x(this, "promise", (o, e) => {
      if (!e)
        return;
      let a;
      e.loading !== void 0 && (a = this.create({
        ...e,
        promise: o,
        type: "loading",
        message: e.loading,
        description: typeof e.description != "function" ? e.description : void 0
      }));
      const m = o instanceof Promise ? o : o();
      let f = a !== void 0;
      return m.then((g) => {
        if (g && // @ts-expect-error
        typeof g.ok == "boolean" && // @ts-expect-error
        !g.ok) {
          f = !1;
          const b = typeof e.error == "function" ? (
            // @ts-expect-error
            e.error(`HTTP error! status: ${response.status}`)
          ) : e.error, d = typeof e.description == "function" ? (
            // @ts-expect-error
            e.description(`HTTP error! status: ${response.status}`)
          ) : e.description;
          this.create({ id: a, type: "error", message: b, description: d });
        } else if (e.success !== void 0) {
          f = !1;
          const b = typeof e.success == "function" ? e.success(g) : e.success, d = typeof e.description == "function" ? (
            // @ts-expect-error
            e.description(g)
          ) : e.description;
          this.create({ id: a, type: "success", message: b, description: d });
        }
      }).catch((g) => {
        if (e.error !== void 0) {
          f = !1;
          const b = typeof e.error == "function" ? e.error(g) : e.error, d = typeof e.description == "function" ? (
            // @ts-expect-error
            e.description(g)
          ) : e.description;
          this.create({ id: a, type: "error", message: b, description: d });
        }
      }).finally(() => {
        var g;
        f && (this.dismiss(a), a = void 0), (g = e.finally) == null || g.call(e);
      }), a;
    });
    // We can't provide the toast we just created as a prop as we didn't create it yet, so we can create a default toast object, I just don't know how to use function in argument when calling()?
    x(this, "custom", (o, e) => {
      const a = (e == null ? void 0 : e.id) || pt++;
      return this.publish({ component: o, id: a, ...e }), a;
    });
    this.subscribers = [], this.toasts = [];
  }
}
const C = new Nt(), Ft = (r, o) => {
  const e = (o == null ? void 0 : o.id) || pt++;
  return C.create({
    message: r,
    id: e,
    type: "default",
    ...o
  }), e;
}, Rt = Ft, We = Object.assign(Rt, {
  success: C.success,
  info: C.info,
  warning: C.warning,
  error: C.error,
  custom: C.custom,
  message: C.message,
  promise: C.promise,
  dismiss: C.dismiss,
  loading: C.loading
}), Z = (r, o) => {
  const e = r.__vccOpts || r;
  for (const [a, m] of o)
    e[a] = m;
  return e;
}, _t = {}, Wt = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stoke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, Ut = /* @__PURE__ */ H("line", {
  x1: "18",
  y1: "6",
  x2: "6",
  y2: "18"
}, null, -1), Vt = /* @__PURE__ */ H("line", {
  x1: "6",
  y1: "6",
  x2: "18",
  y2: "18"
}, null, -1), jt = [
  Ut,
  Vt
];
function Kt(r, o) {
  return i(), u("svg", Wt, jt);
}
const Xt = /* @__PURE__ */ Z(_t, [["render", Kt]]), Gt = () => {
  const r = p(!1);
  return W(() => {
    const o = () => {
      r.value = document.hidden;
    };
    return document.addEventListener("visibilitychange", o), () => window.removeEventListener("visibilitychange", o);
  }), {
    isDocumentHidden: r
  };
}, Zt = ["aria-live", "data-styled", "data-mounted", "data-promise", "data-removed", "data-visible", "data-y-position", "data-x-position", "data-index", "data-front", "data-swiping", "data-dismissible", "data-type", "data-invert", "data-swipe-out", "data-expanded"], qt = ["aria-label", "data-disabled"], Jt = {
  key: 0,
  "data-icon": ""
}, Qt = { "data-content": "" }, te = {
  key: 1,
  "data-buttons": ""
}, ee = ["onClick"], ae = 4e3, oe = 14, se = 20, ne = 200, re = /* @__PURE__ */ gt({
  __name: "Toast",
  props: {
    toast: {},
    toasts: {},
    index: {},
    expanded: { type: Boolean },
    invert: { type: Boolean },
    heights: {},
    gap: {},
    position: {},
    visibleToasts: {},
    expandByDefault: { type: Boolean },
    closeButton: { type: Boolean },
    interacting: { type: Boolean },
    duration: {},
    descriptionClass: {},
    style: {},
    cancelButtonStyle: {},
    actionButtonStyle: {},
    unstyled: { type: Boolean },
    loadingIcon: {},
    class: {},
    classes: {},
    icons: {},
    closeButtonAriaLabel: {},
    pauseWhenPageIsHidden: { type: Boolean },
    cn: { type: Function }
  },
  emits: ["update:heights", "removeToast"],
  setup(r, { emit: o }) {
    const e = o, a = r, m = p(!1), f = p(!1), g = p(!1), b = p(!1), d = p(0), O = p(0), D = p(null), E = p(null), P = k(() => a.index === 0), A = k(() => a.index + 1 <= a.visibleToasts), T = k(() => a.toast.type), K = k(() => a.toast.dismissible !== !1), ct = k(() => {
      var t, l, v, S, w, h, M;
      return a.cn(
        (t = a.classes) == null ? void 0 : t.toast,
        (v = (l = a.toast) == null ? void 0 : l.classes) == null ? void 0 : v.toast,
        (S = a.classes) == null ? void 0 : S.default,
        (w = a.classes) == null ? void 0 : w[a.toast.type || "default"],
        (M = (h = a.toast) == null ? void 0 : h.classes) == null ? void 0 : M[a.toast.type || "default"]
      );
    }), ut = a.toast.style || {}, q = k(
      () => a.heights.findIndex((t) => t.toastId === a.toast.id) || 0
    ), ft = k(() => a.toast.closeButton ?? a.closeButton), s = k(
      () => a.toast.duration || a.duration || ae
    ), n = p(0), c = p(0), B = p(s.value), $ = p(0), y = p(null), L = k(() => a.position.split("-")), J = k(() => L.value[0]), Q = k(() => L.value[1]), tt = typeof a.toast.title != "string", et = typeof a.toast.description != "string", at = k(() => a.heights.reduce((t, l, v) => v >= q.value ? t : t + l.height, 0)), ot = Gt(), st = k(() => a.toast.invert || a.invert), U = k(() => T.value === "loading");
    xt(() => {
      if (!m.value) return;
      const t = E.value, l = t == null ? void 0 : t.style.height;
      t.style.height = "auto";
      const v = t.getBoundingClientRect().height;
      t.style.height = l, O.value = v;
      let S;
      a.heights.find(
        (h) => h.toastId === a.toast.id
      ) ? S = a.heights.map(
        (h) => h.toastId === a.toast.id ? { ...h, height: v } : h
      ) : S = [
        {
          toastId: a.toast.id,
          height: v,
          position: a.toast.position
        },
        ...a.heights
      ], e("update:heights", S);
    });
    let V;
    const z = (t = 0) => (V = setTimeout(() => {
      f.value = !0, d.value = c.value;
      const l = a.heights.filter(
        (v) => v.toastId !== a.toast.id
      );
      e("update:heights", l), setTimeout(() => {
        e("removeToast", a.toast);
      }, ne);
    }, t), V), Et = () => {
      var t, l;
      U.value || !K.value || (z(), (l = (t = a.toast).onDismiss) == null || l.call(t, a.toast));
    }, It = (t) => {
      U.value || !K.value || (D.value = /* @__PURE__ */ new Date(), d.value = c.value, t.target.setPointerCapture(t.pointerId), t.target.tagName !== "BUTTON" && (g.value = !0, y.value = { x: t.clientX, y: t.clientY }));
    }, Pt = (t) => {
      var w, h, M, Y;
      if (b.value) return;
      y.value = null;
      const l = Number(
        ((w = E.value) == null ? void 0 : w.style.getPropertyValue("--swipe-amount").replace("px", "")) || 0
      ), v = (/* @__PURE__ */ new Date()).getTime() - D.value.getTime(), S = Math.abs(l) / v;
      if (Math.abs(l) >= se || S > 0.11) {
        d.value = c.value, (M = (h = a.toast).onDismiss) == null || M.call(h, a.toast), z(), b.value = !0;
        return;
      }
      (Y = E.value) == null || Y.style.setProperty("--swipe-amount", "0px"), g.value = !1;
    }, At = (t) => {
      var Y;
      if (!y.value) return;
      const l = t.clientY - y.value.y, v = t.clientX - y.value.x, w = (L.value[0] === "top" ? Math.min : Math.max)(0, l), h = t.pointerType === "touch" ? 10 : 2;
      Math.abs(w) > h ? (Y = E.value) == null || Y.style.setProperty("--swipe-amount", `${l}px`) : Math.abs(v) > h && (y.value = null);
    };
    return W(() => {
      c.value = q.value * oe + at.value;
    }), W((t) => {
      if (a.toast.promise && T.value === "loading" || a.toast.duration === 1 / 0 || a.toast.type === "loading")
        return;
      let l;
      const v = () => {
        if ($.value < n.value) {
          const w = (/* @__PURE__ */ new Date()).getTime() - n.value;
          B.value = B.value - w;
        }
        $.value = (/* @__PURE__ */ new Date()).getTime();
      }, S = () => {
        n.value = (/* @__PURE__ */ new Date()).getTime(), l = setTimeout(() => {
          var w, h;
          (h = (w = a.toast).onAutoClose) == null || h.call(w, a.toast), z();
        }, B.value);
      };
      a.expanded || a.interacting || a.pauseWhenPageIsHidden && ot ? v() : S(), t(() => {
        clearTimeout(l);
      });
    }), W(() => {
      a.toast.delete && z();
    }), xt(() => {
      if (E.value) {
        const t = E.value.getBoundingClientRect().height;
        O.value = t;
        const l = [
          { toastId: a.toast.id, height: t, position: a.toast.position },
          ...a.heights
        ];
        e("update:heights", l);
      }
      m.value = !0;
    }), Dt(() => {
      if (E.value) {
        const t = a.heights.filter(
          (l) => l.toastId !== a.toast.id
        );
        e("update:heights", t);
      }
      clearTimeout(V);
    }), (t, l) => {
      var v, S, w, h, M, Y, ht, mt, vt, yt;
      return i(), u("li", {
        "aria-live": t.toast.important ? "assertive" : "polite",
        "aria-atomic": "true",
        role: "status",
        tabindex: "0",
        ref_key: "toastRef",
        ref: E,
        "data-sonner-toast": "",
        class: _(ct.value),
        "data-styled": !(t.toast.component || (v = t.toast) != null && v.unstyled || t.unstyled),
        "data-mounted": m.value,
        "data-promise": !!t.toast.promise,
        "data-removed": f.value,
        "data-visible": A.value,
        "data-y-position": J.value,
        "data-x-position": Q.value,
        "data-index": t.index,
        "data-front": P.value,
        "data-swiping": g.value,
        "data-dismissible": K.value,
        "data-type": T.value,
        "data-invert": st.value,
        "data-swipe-out": b.value,
        "data-expanded": !!(t.expanded || t.expandByDefault && m.value),
        style: Ct({
          "--index": t.index,
          "--toasts-before": t.index,
          "--z-index": t.toasts.length - t.index,
          "--offset": `${f.value ? d.value : c.value}px`,
          "--initial-height": t.expandByDefault ? "auto" : `${O.value}px`,
          ...t.style,
          ...lt(ut)
        }),
        onPointerdown: It,
        onPointerup: Pt,
        onPointermove: At
      }, [
        ft.value && !t.toast.component ? (i(), u("button", {
          key: 0,
          "aria-label": t.closeButtonAriaLabel || "Close toast",
          "data-disabled": U.value,
          "data-close-button": "",
          class: _(t.cn((S = t.classes) == null ? void 0 : S.closeButton, (h = (w = t.toast) == null ? void 0 : w.classes) == null ? void 0 : h.closeButton)),
          onClick: Et
        }, [
          j(Xt)
        ], 10, qt)) : F("", !0),
        t.toast.component ? (i(), G(nt(t.toast.component), it({ key: 1 }, t.toast.componentProps, { onCloseToast: z }), null, 16)) : (i(), u(R, { key: 2 }, [
          T.value !== "default" || t.toast.icon || t.toast.promise ? (i(), u("div", Jt, [
            (t.toast.promise || T.value === "loading") && !t.toast.icon ? I(t.$slots, "loading-icon", { key: 0 }) : F("", !0),
            t.toast.icon ? (i(), G(nt(t.toast.icon), { key: 1 })) : (i(), u(R, { key: 2 }, [
              T.value === "success" ? I(t.$slots, "success-icon", { key: 0 }) : T.value === "error" ? I(t.$slots, "error-icon", { key: 1 }) : T.value === "warning" ? I(t.$slots, "warning-icon", { key: 2 }) : T.value === "info" ? I(t.$slots, "info-icon", { key: 3 }) : F("", !0)
            ], 64))
          ])) : F("", !0),
          H("div", Qt, [
            H("div", {
              "data-title": "",
              class: _(t.cn((M = t.classes) == null ? void 0 : M.title, (Y = t.toast.classes) == null ? void 0 : Y.title))
            }, [
              tt ? (i(), G(nt(t.toast.title), kt(it({ key: 0 }, t.toast.componentProps)), null, 16)) : (i(), u(R, { key: 1 }, [
                Tt(rt(t.toast.title), 1)
              ], 64))
            ], 2),
            t.toast.description ? (i(), u("div", {
              key: 0,
              "data-description": "",
              class: _(
                t.cn(
                  t.descriptionClass,
                  t.toast.descriptionClass,
                  (ht = t.classes) == null ? void 0 : ht.description,
                  (mt = t.toast.classes) == null ? void 0 : mt.description
                )
              )
            }, [
              et ? (i(), G(nt(t.toast.description), kt(it({ key: 0 }, t.toast.componentProps)), null, 16)) : (i(), u(R, { key: 1 }, [
                Tt(rt(t.toast.description), 1)
              ], 64))
            ], 2)) : F("", !0)
          ]),
          t.toast.cancel || t.toast.action ? (i(), u("div", te, [
            t.toast.cancel ? (i(), u("button", {
              key: 0,
              class: _(t.cn((vt = t.classes) == null ? void 0 : vt.cancelButton, (yt = t.toast.classes) == null ? void 0 : yt.cancelButton)),
              "data-button": "",
              "data-cancel": "",
              onClick: l[0] || (l[0] = () => {
                var N;
                z(), (N = t.toast.cancel) != null && N.onClick && t.toast.cancel.onClick();
              })
            }, rt(t.toast.cancel.label), 3)) : F("", !0),
            t.toast.action ? (i(!0), u(R, { key: 1 }, dt(Array.isArray(t.toast.action) ? t.toast.action : [t.toast.action], (N, zt) => {
              var bt;
              return i(), u("button", {
                key: zt,
                class: _(t.cn((bt = t.classes) == null ? void 0 : bt.actionButton, N == null ? void 0 : N.classes)),
                "data-button": "",
                onClick: (wt) => {
                  N.onClick(wt, {
                    dismiss: z
                  }), wt.defaultPrevented;
                }
              }, rt(N.label), 11, ee);
            }), 128)) : F("", !0)
          ])) : F("", !0)
        ], 64))
      ], 46, Zt);
    };
  }
}), ie = ["data-visible"], le = { class: "sonner-spinner" }, de = /* @__PURE__ */ gt({
  __name: "Loader",
  props: {
    visible: { type: Boolean }
  },
  setup(r) {
    const o = Array(12).fill(0);
    return (e, a) => (i(), u("div", {
      class: "sonner-loading-wrapper",
      "data-visible": e.visible
    }, [
      H("div", le, [
        (i(!0), u(R, null, dt(lt(o), (m) => (i(), u("div", {
          key: `spinner-bar-${m}`,
          class: "sonner-loading-bar"
        }))), 128))
      ])
    ], 8, ie));
  }
}), ce = {}, ue = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, fe = /* @__PURE__ */ H("path", {
  "fill-rule": "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z",
  "clip-rule": "evenodd"
}, null, -1), pe = [
  fe
];
function ge(r, o) {
  return i(), u("svg", ue, pe);
}
const he = /* @__PURE__ */ Z(ce, [["render", ge]]), me = {}, ve = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, ye = /* @__PURE__ */ H("path", {
  "fill-rule": "evenodd",
  d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z",
  "clip-rule": "evenodd"
}, null, -1), be = [
  ye
];
function we(r, o) {
  return i(), u("svg", ve, be);
}
const xe = /* @__PURE__ */ Z(me, [["render", we]]), ke = {}, Te = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  height: "20",
  width: "20"
}, Be = /* @__PURE__ */ H("path", {
  "fill-rule": "evenodd",
  d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z",
  "clip-rule": "evenodd"
}, null, -1), $e = [
  Be
];
function Se(r, o) {
  return i(), u("svg", Te, $e);
}
const Ce = /* @__PURE__ */ Z(ke, [["render", Se]]), Ee = {}, Ie = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, Pe = /* @__PURE__ */ H("path", {
  "fill-rule": "evenodd",
  d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z",
  "clip-rule": "evenodd"
}, null, -1), Ae = [
  Pe
];
function ze(r, o) {
  return i(), u("svg", Ie, Ae);
}
const Me = /* @__PURE__ */ Z(Ee, [["render", ze]]), He = ["aria-label"], Oe = ["dir", "data-theme", "data-rich-colors", "data-y-position", "data-x-position"], De = 3, $t = "32px", Le = 4e3, Ye = 356, St = 14, Ne = typeof window < "u" && typeof document < "u", Fe = /* @__PURE__ */ gt({
  name: "Toaster",
  inheritAttrs: !1,
  __name: "Toaster",
  props: {
    invert: { type: Boolean, default: !1 },
    theme: { default: "light" },
    position: { default: "bottom-right" },
    hotkey: { default: () => ["altKey", "KeyT"] },
    richColors: { type: Boolean, default: !1 },
    expand: { type: Boolean, default: !1 },
    duration: { default: Le },
    gap: { default: St },
    visibleToasts: { default: De },
    closeButton: { type: Boolean, default: !1 },
    toastOptions: { default: () => ({}) },
    class: { default: "" },
    style: { default: () => ({}) },
    offset: { default: $t },
    dir: { default: "auto" },
    icons: {},
    containerAriaLabel: { default: "Notifications" },
    pauseWhenPageIsHidden: { type: Boolean, default: !1 },
    cn: {}
  },
  setup(r) {
    function o(...s) {
      return s.filter(Boolean).join(" ");
    }
    function e() {
      if (typeof window > "u" || typeof document > "u") return "ltr";
      const s = document.documentElement.getAttribute("dir");
      return s === "auto" || !s ? window.getComputedStyle(document.documentElement).direction : s;
    }
    const a = r, m = Lt(), f = p([]), g = k(() => {
      const s = f.value.filter((n) => n.position).map((n) => n.position);
      return s.length > 0 ? Array.from(new Set([a.position].concat(s))) : [a.position];
    }), b = p([]), d = p(!1), O = p(!1), D = p(
      a.theme !== "system" ? a.theme : typeof window < "u" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"
    ), E = k(() => a.cn || o), P = p(null), A = p(null), T = p(!1), K = a.hotkey.join("+").replace(/Key/g, "").replace(/Digit/g, "");
    function ct(s) {
      f.value = f.value.filter(({ id: n }) => n !== s.id);
    }
    const ut = (s) => {
      var n, c;
      T.value && !((c = (n = s.currentTarget) == null ? void 0 : n.contains) != null && c.call(n, s.relatedTarget)) && (T.value = !1, A.value && (A.value.focus({ preventScroll: !0 }), A.value = null));
    }, q = (s) => {
      s.target instanceof HTMLElement && s.target.dataset.dismissible === "false" || T.value || (T.value = !0, A.value = s.relatedTarget);
    }, ft = (s) => {
      s.target && s.target instanceof HTMLElement && s.target.dataset.dismissible === "false" || (O.value = !1);
    };
    return W((s) => {
      const n = C.subscribe((c) => {
        if (c.dismiss) {
          f.value = f.value.map(
            (B) => B.id === c.id ? { ...B, delete: !0 } : B
          );
          return;
        }
        Yt(() => {
          const B = f.value.findIndex(
            ($) => $.id === c.id
          );
          B !== -1 ? f.value.splice(B, 1, c) : f.value = [c, ...f.value];
        });
      });
      s(() => {
        n();
      });
    }), Bt(
      () => a.theme,
      (s) => {
        if (s !== "system") {
          D.value = s;
          return;
        }
        s === "system" && (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? D.value = "dark" : D.value = "light"), !(typeof window > "u") && window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", ({ matches: n }) => {
          n ? D.value = "dark" : D.value = "light";
        });
      }
    ), Bt(
      () => P.value,
      () => {
        if (P.value)
          return () => {
            A.value && (A.value.focus({ preventScroll: !0 }), A.value = null, T.value = !1);
          };
      }
    ), W(() => {
      f.value.length <= 1 && (d.value = !1);
    }), W((s) => {
      function n(c) {
        const B = a.hotkey.every(
          (L) => c[L] || c.code === L
        ), $ = Array.isArray(P.value) ? P.value[0] : P.value;
        B && (d.value = !0, $ == null || $.focus());
        const y = document.activeElement === P.value || ($ == null ? void 0 : $.contains(document.activeElement));
        c.code === "Escape" && y && (d.value = !1);
      }
      Ne && (document.addEventListener("keydown", n), s(() => {
        document.removeEventListener("keydown", n);
      }));
    }), (s, n) => (i(), u("section", {
      "aria-label": `${s.containerAriaLabel} ${lt(K)}`,
      tabIndex: -1
    }, [
      (i(!0), u(R, null, dt(g.value, (c, B) => {
        var $;
        return i(), u("ol", it({
          key: c,
          ref_for: !0,
          ref_key: "listRef",
          ref: P,
          "data-sonner-toaster": "",
          class: s.class,
          dir: s.dir === "auto" ? e() : s.dir,
          tabIndex: -1,
          "data-theme": s.theme,
          "data-rich-colors": s.richColors,
          "data-y-position": c.split("-")[0],
          "data-x-position": c.split("-")[1],
          style: {
            "--front-toast-height": `${($ = b.value[0]) == null ? void 0 : $.height}px`,
            "--offset": typeof s.offset == "number" ? `${s.offset}px` : s.offset || $t,
            "--width": `${Ye}px`,
            "--gap": `${St}px`,
            ...s.style,
            ...lt(m).style
          },
          onBlur: ut,
          onFocus: q,
          onMouseenter: n[1] || (n[1] = (y) => d.value = !0),
          onMousemove: n[2] || (n[2] = (y) => d.value = !0),
          onMouseleave: n[3] || (n[3] = () => {
            O.value || (d.value = !1);
          }),
          onPointerdown: ft,
          onPointerup: n[4] || (n[4] = (y) => O.value = !1)
        }, s.$attrs), [
          (i(!0), u(R, null, dt(f.value.filter(
            (y) => !y.position && B === 0 || y.position === c
          ), (y, L) => {
            var J, Q, tt, et, at, ot, st, U, V;
            return i(), G(re, {
              key: y.id,
              index: L,
              toast: y,
              duration: ((J = s.toastOptions) == null ? void 0 : J.duration) ?? s.duration,
              class: _(((Q = s.toastOptions) == null ? void 0 : Q.class) ?? ""),
              descriptionClass: (tt = s.toastOptions) == null ? void 0 : tt.descriptionClass,
              invert: s.invert,
              visibleToasts: s.visibleToasts,
              closeButton: ((et = s.toastOptions) == null ? void 0 : et.closeButton) ?? s.closeButton,
              interacting: O.value,
              position: c,
              style: Ct((at = s.toastOptions) == null ? void 0 : at.style),
              unstyled: (ot = s.toastOptions) == null ? void 0 : ot.unstyled,
              classes: (st = s.toastOptions) == null ? void 0 : st.classes,
              cancelButtonStyle: (U = s.toastOptions) == null ? void 0 : U.cancelButtonStyle,
              actionButtonStyle: (V = s.toastOptions) == null ? void 0 : V.actionButtonStyle,
              toasts: f.value,
              expandByDefault: s.expand,
              gap: s.gap,
              expanded: d.value,
              pauseWhenPageIsHidden: s.pauseWhenPageIsHidden,
              cn: E.value,
              heights: b.value,
              "onUpdate:heights": n[0] || (n[0] = (z) => b.value = z),
              onRemoveToast: ct
            }, {
              "loading-icon": X(() => [
                I(s.$slots, "loading-icon", {}, () => [
                  j(de, {
                    visible: y.type === "loading"
                  }, null, 8, ["visible"])
                ])
              ]),
              "success-icon": X(() => [
                I(s.$slots, "success-icon", {}, () => [
                  j(he)
                ])
              ]),
              "error-icon": X(() => [
                I(s.$slots, "error-icon", {}, () => [
                  j(Me)
                ])
              ]),
              "warning-icon": X(() => [
                I(s.$slots, "warning-icon", {}, () => [
                  j(Ce)
                ])
              ]),
              "info-icon": X(() => [
                I(s.$slots, "info-icon", {}, () => [
                  j(xe)
                ])
              ]),
              _: 2
            }, 1032, ["index", "toast", "duration", "class", "descriptionClass", "invert", "visibleToasts", "closeButton", "interacting", "position", "style", "unstyled", "classes", "cancelButtonStyle", "actionButtonStyle", "toasts", "expandByDefault", "gap", "expanded", "pauseWhenPageIsHidden", "cn", "heights"]);
          }), 128))
        ], 16, Oe);
      }), 128))
    ], 8, He));
  }
}), Ue = {
  install(r) {
    r.component("Toaster", Fe);
  }
};
export {
  Fe as Toaster,
  Ue as default,
  We as toast
};
//# sourceMappingURL=vue-sonner.js.map
